import { Stack } from '@mui/material';
import { StaffDepartmentBlock } from './StaffDepartmentBlock';

export default function StaffTableList({ schedule }) {
  return (
    <Stack>
      {schedule.map((department, index) => (
        <StaffDepartmentBlock key={index} department={department} />
      ))}
    </Stack>
  );
}
